import { Component, computed, input } from '@angular/core';
import { CardCatalogComponent, IChip, ILink, ImageData, ImageDataDb, MediaImage } from '@sirius/common';

import { IRobotOption } from '../../models/robot-selector.model';

@Component({
    selector: 'robot-selector-cobot-card',
    templateUrl: './cobot-card.component.html',
    styleUrl: './cobot-card.component.scss',
    imports: [CardCatalogComponent],
    host: {
        'class': 'robot-card',
        'role': 'article',
    },
})
export class CobotCardComponent {
    readonly robot = input.required<IRobotOption>();
    readonly imageData = input<ImageData>(ImageDataDb.card.small);
    readonly bestMatchLabel = input('');
    readonly viewProductLabel = input.required<string>();
    readonly isBestMatch = input(false);

    // The backend sends the same image model as every other catalog card, focus point included.
    readonly cardImage = computed(() => new MediaImage(this.robot().image));

    protected readonly cardAttributes = computed<IChip[]>(() => {
        const attributes = this.robot().attributes;
        const bestMatchLabel = this.bestMatchLabel().trim();

        return this.isBestMatch() && bestMatchLabel
            ? [{ text: bestMatchLabel, attention: 'brand' }, ...attributes]
            : attributes;
    });

    // Documented selector exception to catalog cards: an explicit "View product" call to action.
    protected readonly productLink = computed<ILink>(() => ({
        href: this.robot().productPageUrl,
        title: this.viewProductLabel(),
    }));
}
